module.exports = __webpack_public_path__ + "static/assets/7ab00ab8daefd87e10f305514cb6a253.png";